import {
    IconCorrelationAnalysis,
    IconDatabase,
    IconDashboard,
    IconFlask,
    IconFunnels,
    IconGraph,
    IconLifecycle,
    IconMessage,
    IconPerson,
    IconRetention,
    IconRewindPlay,
    IconServer,
    IconStickiness,
    IconTerminal,
    IconToggle,
    IconUserPaths,
    IconHogQL,
} from '@posthog/icons'

export const slideButtons = [
    {
        title: 'Funnels',
        Icon: IconFunnels,
        color: 'blue',
    },
    {
        title: 'Graphs & trends',
        Icon: IconGraph,
        color: 'yellow',
    },
    {
        title: 'User paths',
        Icon: IconUserPaths,
        color: 'teal',
    },
    {
        title: 'Correlation analysis',
        Icon: IconCorrelationAnalysis,
        color: 'purple',
    },
    {
        title: 'Retention',
        Icon: IconRetention,
        color: 'salmon',
    },
    {
        title: 'Stickiness',
        Icon: IconStickiness,
        color: 'yellow',
    },
    {
        title: 'Lifecycle',
        Icon: IconLifecycle,
        color: 'seagreen',
    },
    {
        title: 'Dashboards',
        Icon: IconDashboard,
        color: 'seagreen',
    },
    {
        title: 'SQL',
        Icon: IconHogQL,
        color: 'red',
    },
]
